import React from 'react';
import styled from 'styled-components';
import { Icons, ImpButton, ImpContainer, ImpFlex, ImpIcon, ImpPad, ImpText, colors, } from '../..';
export const SNACKBAR_ANIMATION_DURATION_MS = 300;
const Container = styled(ImpContainer) `
  background-color: ${colors.surface.surfaceInverse};
  width: min(100% - 32px, 748px);
  border-radius: 8px;

  box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.2),
    0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 10px 15px -3px rgba(0, 0, 0, 0.2),
    0px 20px 25px -5px rgba(0, 0, 0, 0.2);

  height: fit-content;
  position: fixed;

  bottom: ${(props) => props.isVisible ? `${24 + props.index * 10}px` : '-48px'};
  opacity: ${(props) => (props.isVisible ? 1 : '0')};
  transform: ${(props) => (props.isVisible ? 'scale(1)' : 'scale(0.98)')};

  z-index: ${(props) => (props.index ? 1000 - props.index : 1000)};

  opacity: ${(props) => (props.isVisible ? 1 - props.index / 4 : '0')};

  transition: bottom ${SNACKBAR_ANIMATION_DURATION_MS}ms
      cubic-bezier(0.25, 0.8, 0.25, 1),
    opacity ${SNACKBAR_ANIMATION_DURATION_MS}ms cubic-bezier(0.35, 0.9, 0.35, 1),
    transform ${SNACKBAR_ANIMATION_DURATION_MS}ms
      cubic-bezier(0.25, 0.8, 0.25, 1),
    box-shadow ${SNACKBAR_ANIMATION_DURATION_MS}ms
      cubic-bezier(0.25, 0.8, 0.25, 1);
`;
const Wrapper = styled(ImpFlex) ``;
export default function ImpSnackbar({ snackbar, index, }) {
    const { isVisible, text, type, buttonText, buttonClick } = snackbar;
    const TextContent = () => (React.createElement(ImpText, { typography: "body1", color: colors.content.onBackgroundInverse }, text));
    if (type === 'success') {
        return (React.createElement(Wrapper, { direction: "row", justify: "center" },
            React.createElement(Container, { isVisible: isVisible, index: index },
                React.createElement(ImpPad, { padding: "16px" },
                    React.createElement(ImpFlex, { direction: "row", align: "center", gap: "l" },
                        React.createElement(ImpContainer, null,
                            React.createElement(ImpIcon, { iconSrc: Icons.circleWavyCheck, stroke: colors.content.onBackgroundSuccess })),
                        React.createElement(TextContent, null))))));
    }
    return (React.createElement(Wrapper, { direction: "row", justify: "center" },
        React.createElement(Container, { isVisible: isVisible, index: index },
            React.createElement(ImpPad, { padding: "16px" },
                React.createElement(ImpFlex, { direction: "row", justify: "space-between", align: "center" },
                    React.createElement(TextContent, null),
                    buttonText && (React.createElement(ImpButton, { variant: "text", buttonStyle: "color", color: colors.content.onBackgroundInverse, onClick: buttonClick }, buttonText)))))));
}
//# sourceMappingURL=ImpSnackbar.js.map